import { render, staticRenderFns } from "./RsaPazienteRiunioneEquipePage.vue?vue&type=template&id=74485489"
import script from "./RsaPazienteRiunioneEquipePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiunioneEquipePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports